import { ViewColumn } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import documentServices from '../services/documentServices';
import { useAlert } from '../../../context/AlertContext';
import { CircularProgress, LinearProgress } from '@mui/material';

function DocumentBarcodeAssign({documentId,callBack}) {

    const {AppAlert } = useAlert();
    const [documentBarcode,setDocumentBarcode] = useState(null);
    const [barcodeInput,setBarcodeInput] = useState("");
    const [saving,setSavingStatus]  = useState(false);



    const getDocumentBarcode = () =>{
        setSavingStatus(true);
        documentServices.getBarcodeByDocumentId(documentId).then(res=>{
            if(res.data !== null ){
                setDocumentBarcode(res.data.barcode);
            }
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
        })
    }


    const assignBarcode = () => {
        let payload = {
            documentId :documentId,
            barcode :barcodeInput
        }
        setSavingStatus(true);
        documentServices.barcodeAssign(payload).then(res=>{
            AppAlert(res.msg)
            getDocumentBarcode();
            callBack();
        }).catch(error=>{
            console.log(error)
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const handleKeyUp = (e) =>{
        if(e.key === 'Enter') {
            e.preventDefault();
            assignBarcode();
        }
    }

    useEffect(()=>{
        getDocumentBarcode();
    },[])
  
    return (
        <>
            {saving ? 
                <sapn className="float-end"><CircularProgress/></sapn>
                :
                <>
                    {documentBarcode === null ?
                        <div className="input-group float-end" style={{width:300}}>
                            <span className="input-group-text"><ViewColumn/></span>
                            <input type="text" className="form-control"
                                value={barcodeInput} 
                                onChange={(e)=>
                                    setBarcodeInput(e.target.value)
                                }
                                onKeyUp={handleKeyUp} 
                                placeholder="Scan barcode to assign"
                            />
                        </div>
                        :
                        <span className='float-end'> <spoan className="barcode">{documentBarcode}</spoan></span>
                    }
                </>
            }
            
        </>
    )

}

export default DocumentBarcodeAssign